// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getText } from 'conversations-message-history/email-capture-prompt/operators/emailCapturePromptMessageGetters';
import { AGENT } from 'conversations-message-history/constants/messageUses';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import ContentText from '../primary-message/ContentText';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import AutomatedMessageHeader from '../shared/components/AutomatedMessageHeader';
import styled from 'styled-components';
import AutomatedMessageAvatar from '../avatar/AutomatedMessageAvatar';
import AutomatedMessageContent from '../shared/components/AutomatedMessageContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "EmailCapturePromptMessage__StyledDiv",
  componentId: "sc-15ai9s8-0"
})(["display:flex;align-items:center;flex-direction:column;width:100%;"]);
const StyledContentColumn = styled.div.withConfig({
  displayName: "EmailCapturePromptMessage__StyledContentColumn",
  componentId: "sc-15ai9s8-1"
})(["display:flex;flex-direction:row;"]);
const EmailCapturePromptMessage = ({
  message,
  positionDescriptors
}) => {
  return /*#__PURE__*/_jsx(PrimaryMessage, {
    positionDescriptors: positionDescriptors,
    use: AGENT,
    children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
      children: /*#__PURE__*/_jsxs(StyledContentColumn, {
        children: [/*#__PURE__*/_jsx(AutomatedMessageAvatar, {}), /*#__PURE__*/_jsxs(StyledDiv, {
          children: [/*#__PURE__*/_jsx(AutomatedMessageHeader, {
            message: message
          }), /*#__PURE__*/_jsx(AutomatedMessageContent, {
            children: /*#__PURE__*/_jsx(ContentText, {
              contentText: getText(message)
            })
          })]
        })]
      })
    })
  });
};
EmailCapturePromptMessage.displayName = 'EmailCapturePromptMessage';
EmailCapturePromptMessage.propTypes = {
  message: RecordPropType('EmailCapturePromptMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default EmailCapturePromptMessage;